module.exports = __webpack_public_path__ + "img/fi-rr-expand.ad59b27d.svg";